import React, { useEffect, useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import api from "../../api";
import Can from "../../components/Can";
import AddProjectModuleDialog from "./AddProjectModuleDialog";

// Phase 4C, §12/§13. Module dropdown sourced from GET
// /form-assignment-options/projects/:projectId/modules — server re-validates
// the caller actually has access to projectId, so a forged/foreign
// project_id can never leak its module list. "+ Add Module" requires both
// a selected project AND the existing project_modules.create permission.
export default function FormAssignmentModuleSelector({ projectId, value, onChange, isDisabled = false }) {
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAdd, setShowAdd] = useState(false);

  const fetchModules = async () => {
    if (!projectId) { setModules([]); return; }
    setLoading(true);
    try {
      const res = await api.get(`/form-assignment-options/projects/${projectId}/modules`, { params: { pageSize: 200 } });
      setModules(Array.isArray(res.data?.data) ? res.data.data : []);
    } catch (err) {
      console.error("Fetch assignable modules error:", err);
      setModules([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchModules();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  const handleCreated = (projectModule) => {
    setShowAdd(false);
    fetchModules().then(() => onChange(projectModule.id));
  };

  return (
    <>
      <InputGroup>
        <Form.Select value={value || ""} disabled={isDisabled || !projectId || loading} onChange={(e) => onChange(e.target.value)}>
          <option value="">{!projectId ? "Select a project first" : loading ? "Loading modules..." : "Select module (optional)..."}</option>
          {modules.map((m) => (
            <option key={m.id} value={m.id}>{m.name}</option>
          ))}
        </Form.Select>
        <Can moduleKey="project_modules" actionKey="create">
          <Button variant="outline-secondary" type="button" disabled={isDisabled || !projectId} onClick={() => setShowAdd(true)}>
            + Add Module
          </Button>
        </Can>
      </InputGroup>

      <AddProjectModuleDialog show={showAdd} projectId={projectId} onClose={() => setShowAdd(false)} onCreated={handleCreated} />
    </>
  );
}
